import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { filter, first, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthService {
    constructor(private oidcSecurityService: OidcSecurityService) {
        this.oidcSecurityService.userData$.subscribe((user) => {
            if (user) {
                this.setCache("permissions", user.perms);
                this.setCache("full_name", user.full_name);
                this.setCache("userName", user.name);
            }
            else {
                this.setCache("permissions", []);
                this.setCache("full_name", "");
                this.setCache("userName", "");
            }
        });
    }

    get isLoggedIn() {
        return this.oidcSecurityService.isAuthenticated$;
    }

    get token() {
        return this.oidcSecurityService.getToken();
    }

    get userData() {
        return this.oidcSecurityService.userData$;
    }

    get permissions() {
        return this.oidcSecurityService.userData$.pipe(map(user => {
            if (user === null || user === undefined) return [];
            return user.perms;
        }
        ));
    }

    hasPermission(code: string): boolean {
        var cachedPermissions = this.getCache("permissions");
        return cachedPermissions !== null && cachedPermissions !== undefined && cachedPermissions.includes(code);
    }

    checkAuth() {
        return this.oidcSecurityService.checkAuth();
    }

    doLogin() {
        return of(this.oidcSecurityService.authorize());
    }

    signOut() {
        this.clearCache("permissions");
        this.clearCache("full_name");
        this.clearCache("userName");
        this.oidcSecurityService.logoff();
    }

    private clearCache(key: string) {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.error('Error removing data from localStorage', e);
        }
    }

    private setCache(key: string, data: any): void {
        try {
            localStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
            console.error('Error saving to localStorage', e);
        }
    }

    private getCache(key: string) {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            console.error('Error getting data from localStorage', e);
            return null;
        }
    }

    getuserName(): string {
        let userName = this.getCache("userName");
        return userName;
    }
}
